import React, { MouseEvent } from "react";
import { DerbyEventStatus, HomepageEventBannerText } from "@fdr/types/ts/Derby";
import { HomepageCTA } from "@fdr/home/src/utils/types";
import { NullaryFn, UnaryFn } from "@tvg/ts-types/Functional";
import HomeHeaderBanner from "../../_organisms/HomeHeaderBanner";
import HomeHeaderFooter from "../../_organisms/HomeHeaderFooter";
import { FooterButton } from "../../_organisms/HomeHeaderFooter/types";
import DerbyPicks from "../../_organisms/DerbyPicks";
import { Props as DerbyPickProps } from "../../_molecules/DerbyPick";
import { Container } from "./styled-components";

export interface Props {
  raceStartDate?: Date | null;
  eventStatus: DerbyEventStatus;
  title?: HomepageEventBannerText;
  subtitle?: HomepageEventBannerText;
  description?: HomepageEventBannerText;
  showDerbyPicks: boolean;
  derbyPicks: DerbyPickProps[];
  isNumberFire: boolean;
  derbyRaceUrl: string;
  promoText?: string;
  headerCTA?: HomepageCTA | null;
  onHeaderClick: NullaryFn<void>;
  onPromoClick: UnaryFn<MouseEvent<HTMLDivElement>, void>;
  onFooterButtonClick: UnaryFn<FooterButton, void>;
  baseBet?: number;
}

const HomeHeader = ({
  raceStartDate,
  eventStatus,
  title,
  subtitle,
  description,
  showDerbyPicks,
  derbyPicks,
  isNumberFire,
  derbyRaceUrl,
  promoText,
  headerCTA,
  onHeaderClick,
  onPromoClick,
  onFooterButtonClick,
  baseBet
}: Props) => (
  <Container data-qa-label="derby-header">
    <HomeHeaderBanner
      title={title}
      subtitle={subtitle}
      description={description}
      raceStartDate={raceStartDate}
      raceStatus={eventStatus}
      promoText={promoText}
      onHeaderClick={onHeaderClick}
      onPromoClick={onPromoClick}
    />

    {eventStatus === DerbyEventStatus.DERBY_DAY && showDerbyPicks && (
      <DerbyPicks
        picks={derbyPicks}
        isNumberFire={isNumberFire}
        baseBet={baseBet}
      />
    )}

    <HomeHeaderFooter
      raceStatus={eventStatus}
      showDerbyPicks={showDerbyPicks}
      derbyRaceUrl={derbyRaceUrl}
      headerCTA={headerCTA}
      onFooterButtonClick={onFooterButtonClick}
    />
  </Container>
);

export default HomeHeader;
